import type { Location, LocationError } from '../types/location';
import io from './ioService';
import storage from './localStorageService';

class GeoLocationService {
  sendLocation = (location: Location) => {
    const id = storage.get('id');
    const payload = {
      available: true,
      coordinates: {
        latitude: location.latitude,
        longitude: location.longitude,
      },
    };
    io.send({
      event: 'location',
      data: { id, type: 'location', data: payload },
    });
  };

  sendLocationError = (error: LocationError) => {
    const id = storage.get('id');
    io.send({
      event: 'location',
      data: {
        id,
        type: 'location',
        data: {
          available: false,
          error: `#${error.code} - with message: ${error.message}`,
        },
      },
    });
  };
}

export default new GeoLocationService();
